import { apiFetch } from './client'
import type { LpState, LpBuildTxRequest, LpBuildTxResponse, RaydiumPool, OrcaPool } from '../types/lp'

export function fetchLpPositions(portfolioId: string): Promise<LpState[]> {
  return apiFetch<LpState[]>(`/api/lp/${encodeURIComponent(portfolioId)}`)
}

/**
 * Forces an immediate on-chain re-scan (Raydium/Orca) rather than just re-reading the cache —
 * use this for a user-triggered "refresh" action. Plain fetchLpPositions() would silently
 * return the same stale data if the last periodic lazy-probe poll (up to ~100s ago) predates
 * an on-chain change, e.g. one made directly in Orca's own UI.
 */
export function refreshLpPositions(portfolioId: string): Promise<LpState[]> {
  return apiFetch<LpState[]>(`/api/lp/${encodeURIComponent(portfolioId)}/refresh`, {
    method: 'POST',
  })
}

export function buildLpTx(portfolioId: string, req: LpBuildTxRequest): Promise<LpBuildTxResponse> {
  return apiFetch<LpBuildTxResponse>(`/api/lp/${encodeURIComponent(portfolioId)}/build-tx`, {
    method: 'POST',
    body: JSON.stringify(req),
  })
}

export async function fetchRaydiumPools(mint1: string, mint2: string, poolType = 'concentrated'): Promise<RaydiumPool[]> {
  const params = new URLSearchParams({ mint1, mint2, poolType, pageSize: '3' })
  const resp = await apiFetch<unknown>(`/api/raydium/pool?${params}`)
  const list = (resp as any)?.data?.data ?? (resp as any)?.data ?? resp
  return (Array.isArray(list) ? list : []) as RaydiumPool[]
}

export async function fetchOrcaPools(mint1: string, mint2: string): Promise<OrcaPool[]> {
  const params = new URLSearchParams({ mint1, mint2, pageSize: '3' })
  const resp = await apiFetch<unknown>(`/api/orca/pool?${params}`)
  const list = (resp as any)?.data ?? resp
  return (Array.isArray(list) ? list : []) as OrcaPool[]
}
